"use client";
import { keys } from "../../../../core/utils/keys/keys.mjs";
import { getBaseSize } from "../get-base-size/get-base-size.mjs";
import { isPrimitiveSize } from "../is-primitive-size/is-primitive-size.mjs";
import { isResponsiveSize } from "../is-responsive-size/is-responsive-size.mjs";
import { getPaddingValue } from "../get-padding-value/get-padding-value.mjs";
//#region packages/@mantine/core/src/components/AppShell/AppShellMediaStyles/assign-padding-variables/assign-padding-variables.ts
function assignPaddingVariables({ padding, baseStyles, minMediaStyles }) {
	if (isPrimitiveSize(padding)) baseStyles["--app-shell-padding"] = getPaddingValue(getBaseSize(padding));
	if (isResponsiveSize(padding)) {
		if (padding.base) baseStyles["--app-shell-padding"] = getPaddingValue(padding.base);
		keys(padding).forEach((key) => {
			if (key !== "base") {
				minMediaStyles[key] = minMediaStyles[key] || {};
				minMediaStyles[key]["--app-shell-padding"] = getPaddingValue(padding[key]);
			}
		});
	}
}
//#endregion
export { assignPaddingVariables };

//# sourceMappingURL=assign-padding-variables.mjs.map